import script from "./FamilypackView.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilypackView.vue?vue&type=script&setup=true&lang=js"

import "./FamilypackView.vue?vue&type=style&index=0&id=1d0dd481&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0dd481"]])

export default __exports__